import React from "react"
import Cabecalho from "../Cabecalho"
import { BrindesResgatadosLista } from "./components/BrindesResgatadosLista"

export function BrindesResgatadosFornecedor() {
    return (
        <>
            <Cabecalho pagina="Brindes Resgatados" />
            <BrindesResgatadosLista />
        </>
    )
}
